import React, { useEffect, useState } from 'react';
import { HistoryItem, WorkflowView, getAutomationWorkflowHistory } from '../../../api/cafAutomation';
import { Drawer } from '../Overlay';
import { HistoryList } from './formBits';

export const WorkflowHistoryDrawer: React.FC<{ view: WorkflowView; onClose: () => void }> = ({ view, onClose }) => {
  const [items, setItems] = useState<HistoryItem[] | null>(null);
  const [problem, setProblem] = useState('');
  useEffect(() => {
    let alive = true;
    getAutomationWorkflowHistory(view.workflow_id).then(
      (data) => { if (alive) setItems(data.items); },
      () => { if (alive) setProblem("Couldn't load the history. Close and try again."); },
    );
    return () => { alive = false; };
  }, [view.workflow_id]);
  return (
    <Drawer eyebrow="Workflow history" title={view.name} onClose={onClose}
      footer={<button type="button" className="ui-btn ui-btn--ghost ui-btn--md" onClick={onClose}>Close</button>}>
      <HistoryList items={items} problem={problem} workflowId={view.workflow_id} empty="Nothing has changed yet." />
    </Drawer>
  );
};
